<template>
  <v-card ripple link flat :to="route">
    <v-row no-gutters>
      <v-col cols="3" sm="12">
        <v-img
          v-if="poster"
          :aspect-ratio="2 / 3"
          class="white--text align-end rounded grey lighten-2"
          :src="poster"
          :lazy-src="poster"
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
        <v-img
          v-else
          :aspect-ratio="2 / 3"
          class="white--text align-end"
          src="../assets/empty/no-poster.svg"
        />
      </v-col>
      <v-col cols="8" sm="12">
        <v-card-subtitle class="text-truncate pb-0 event-date">
          <div v-if="is_post_event" class="red--text overline">
            Event Berakhir
          </div>
          <div v-else class="overline">{{ date }}</div>
        </v-card-subtitle>
        <v-card-title
          class="pt-0 subtitle-2 font-weight-bold text-break"
          style="width: 100%"
          >{{ title }}
        </v-card-title>
        <v-card-subtitle class="text-truncate">
          {{ publisher }}
          <v-avatar
            color="blue"
            size="12"
            class="ml-1"
            v-if="publisher_badge == 1"
          >
            <v-icon color="white" x-small>done</v-icon>
          </v-avatar>
        </v-card-subtitle>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: 'PosterCard',
  props: {
    title: String,
    date: String,
    is_post_event: Boolean,
    poster: String,
    publisher: String,
    publisher_badge: Number,
    route: Object,
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.rounded {
  border-radius: 5px;
  border: 1px solid #dbdbdb;
}
@media only screen and (max-width: 600px) {
  .event-date {
    padding-top: 0px;
  }
}
</style>
